<template>
  <section class="p-2">
    <v-card>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="dessertHeaders"
        :items="routeSummary"
        :search="search"
        dense
        item-key="name"
      >
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-icon
              small
              title="Edit"
              color="primary"
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-content-save-edit-outline
            </v-icon>
            <v-icon
              small
              title="Edit"
              color="primary"
              class="mr-2"
              @click="deleteItem(item)"
            >
              mdi-trash-can-outline
            </v-icon>
          </div>
        </template>

        <template v-slot:top>
          <v-card class="pa-2 mt-3 bord-color" elevation="0" rounded outlined>
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="0"
              outlined
              width="90px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
                >Filters
              </p>
            </v-sheet>
            <v-form ref="Searchform" v-model="valid">
              <v-row row-gutters class="px-2">
                <v-col cols="12" lg="2" sm="6" xs="12">
                  <v-autocomplete
                    class="rounded"
                    v-model="filterTxnType"
                    dense
                    outlined
                    placeholder="Transaction type"
                    :items="customer_Type"
                    item-text="txt"
                    item-value="val"
                  ></v-autocomplete>
                </v-col>

                <div class="d-flex mt-1">
                  <div>
                    <v-btn
                      depressed
                      small
                      @click="getAllPayeeRoutes(filterTxnType)"
                      class="mx-2 ms-3 primary text-capitalize"
                      >Get Results</v-btn
                    >
                  </div>
                </div>
              </v-row>
            </v-form>
          </v-card>
          <div class="d-flex">
            <v-btn
              depressed
              small
              class="text-capitalize me-2 ms-2 mt-2 text-decoration-none"
              color="primary"
              @click="openDialog()"
              ><v-icon small>mdi-plus</v-icon>Add Route</v-btn
            >
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              color="primary"
              small
              class="me-5 mt-2"
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-10"
              dense
              clearable
            ></v-text-field>
          </div>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showDialog" width="500">
        <v-card>
          <v-form ref="Addform" v-model="valid">
            <v-toolbar color="secondary" dark flat dense>
              <span>Add Route</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12"
                  ><label class="my-0 required labelFontsize">
                    Transaction type
                  </label>
                  <v-autocomplete
                    class="rounded"
                    v-model="routeDetails.txn_type"
                    dense
                    outlined
                    placeholder="Transaction type"
                    :items="customer_Type"
                    item-text="txt"
                    item-value="val"
                    :rules="type"
                    :disabled="disableCountry"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize required">
                    Sending Country
                  </label>
                  <v-autocomplete
                    v-model="routeDetails.send_country"
                    class="rounded"
                    dense
                    outlined
                    item-text="txt"
                    item-value="val"
                    :disabled="disableCountry"
                    :items="senderCountrys"
                    :rules="FieldRequired('Sender Country')"
                    @input="getSendCountryPartners(routeDetails.send_country)"
                    placeholder="Sender Country"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize required">
                    Channel Partner
                  </label>
                  <v-autocomplete
                    v-model="routeDetails.send_partner"
                    class="rounded"
                    dense
                    outlined
                    item-text="txt"
                    item-value="val"
                    :disabled="disableCountry"
                    :items="senderPartners"
                    :rules="FieldRequired('Channel Partner')"
                    placeholder="Partner"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12"
                  ><label class="my-0 labelFontsize required">
                    Payout Country
                  </label>
                  <v-autocomplete
                    v-model="routeDetails.country_code"
                    class="rounded"
                    dense
                    outlined
                    :disabled="disableCountry"
                    placeholder="Select Country"
                    :rules="FieldRequired('Country')"
                    item-text="txt"
                    item-value="val"
                    :items="countryOptions"
                    @input="getPaymentModes(routeDetails.country_code)"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize required">
                    Payment Mode
                  </label>
                  <v-autocomplete
                    v-model="routeDetails.payment_mode"
                    class="rounded"
                    dense
                    outlined
                    item-text="txt"
                    :rules="FieldRequired('Payment Mode')"
                    item-value="val"
                    :items="method_options"
                    placeholder="Select Payment Mode"
                    @input="
                      getpartnersByCntry(
                        routeDetails.country_code,
                        routeDetails.payment_mode,
                      )
                    "
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize required"
                    >Payout Partner
                  </label>
                  <v-autocomplete
                    v-model="routeDetails.partner_id"
                    class="rounded"
                    dense
                    outlined
                    item-text="txt"
                    item-value="val"
                    :rules="FieldRequired('Partner')"
                    :items="partner_list"
                    placeholder="Select Partner"
                    @input="
                      getBankList(
                        routeDetails.partner_id,
                        routeDetails.payment_mode,
                        true,
                      )
                    "
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize required"> Bank </label>
                  <v-autocomplete
                    v-model="routeDetails.bank"
                    class="rounded"
                    :rules="FieldRequired('Bank')"
                    dense
                    outlined
                    item-text="txt"
                    item-value="val"
                    :items="bank_list"
                    placeholder="Select Bank"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="pa-0 mb-0"></v-divider>
            <v-card-actions class="ma-0 pt-0">
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                @click="addPayeeRoute()"
                ><v-icon small>mdi-content-save-plus-outline</v-icon>Submit
              </v-btn>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                outlined
                @click="closeDialog()"
                ><v-icon small>mdi-close</v-icon>cancel
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom">Delete</v-card-title>
          <v-card-text class="h5 py-3"
            >Are you sure you want to delete ?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deletePayeeRouteById()"
            >
              Delete<v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteDialog = false"
            >
              Close<v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import setupService from "@/services/SetupService/setupService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import commonService from "@/services/CommonService/commonService.js";
import alerts from "@/mixins/alerts";
import { FieldRequired } from "@/utils/validation.js";
export default {
  mixins: [alerts],
  name: "Master Bank Summary",
  data() {
    return {
      // expanded: [],
      search: "",
      FieldRequired,
      loader: false,
      showDialog: false,
      deleteDialog: false,
      delete_id: null,
      valid: true,
      disableCountry: false,
      filterTxnType: "IND",
      countryOptions: [],
      method_options: [],
      partner_list: [],
      senderCountrys: [],
      senderPartners: [],
      customer_Type: [],
      bank_list: [],
      dessertHeaders: [
        {
          text: "Route Id",
          sortable: false,
          value: "route_id",
        },
        {
          text: "Txn Type",
          value: "txn_type",
        },
        { text: "Send Country", value: "send_country" },
        { text: "Channel Partner", value: "send_partner" },
        { text: "Payout Country", value: "country_name" },
        { text: "Payment Mode", value: "payment_mode" },
        { text: "Payout Partner", value: "partner_name" },
        { text: "Bank", value: "bank_name" },
        { text: "Action", value: "action", sortable: false },
      ],
      routeSummary: [],
      routeDetails: {
        txn_type: "",
        send_country: "",
        send_partner: "",
        partner_id: 0,
        country_code: "",
        payment_mode: "",
        route_level: "BW",
        bank: "",
        is_active: true,
      },
    };
  },
  components: {
    OverlayPageVue,
  },
  mounted() {
    this.getcountryList();
    this.getAllPayeeRoutes("IND");
    this.getAllSendCountrys();
    this.getparameterdropdowns("UTP");
  },
  computed: {},
  methods: {
    deleteItem(item) {
      this.deleteDialog = true;
      this.delete_id = item.route_id;
    },
    async deletePayeeRouteById() {
      this.loader = true;
      try {
        const responseData = await setupService.deletePayeeRouteById({
          route_id: this.delete_id,
          is_active: false,
        });
        if (responseData.data.status_code === 200) {
          this.loader = false;
          this.deleteDialog = false;
          this.getAllPayeeRoutes();
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.loader = false;
          this.deleteDialog = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (e) {
        this.loader = false;
        this.deleteDialog = false;
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async getparameterdropdowns(code) {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          this.customer_Type = [
            ...response.data.data.map((i) => {
              return { txt: i.value, val: i.value_code };
            }),
          ];
        }
      } catch (error) {
        this.transItems = [];

        console.error(error);
      }
    },
    async getAllPayeeRoutes(txn_type) {
      this.loader = true;
      try {
        const response = await setupService.getAllPayRoutes({
          route_level: "BW",
          txn_type: txn_type,
        });
        if (response.data.status_code === 200) {
          this.routeSummary = response.data.data[0];
          console.log("CountryWise Data", this.routeSummary);
          this.stoploader();
        } else {
          this.routeSummary == [];
          this.stoploader();
        }
      } catch (error) {
        this.routeSummary = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getById(id) {
      try {
        const response = await setupService.getPayRouteById(id);
        if (response.data.status_code === 200) {
          this.routeDetails = response.data.data[0];
          this.getPaymentModes(this.routeDetails.country_code);
          this.getpartnersByCntry(
            this.routeDetails.country_code,
            this.routeDetails.payment_mode,
          );
          this.getSendCountryPartners(this.routeDetails.send_country);
          this.getBankList(
            this.routeDetails.partner_id,
            this.routeDetails.payment_mode,
            true,
          );
        } else {
          this.showAlertError(response.data.message);
        }
        console.log("Get Id Data", response);
      } catch (error) {
        console.error(error);
      }
    },
    async getAllSendCountrys() {
      try {
        const responseData = await partnerService.getAllSenderCountrys();
        if (responseData.data.status_code === 200) {
          this.senderCountrys = responseData.data.data.map((i) => {
            return { txt: i.name, val: i.iso3 };
          });
        }
        console.log("Send Countrys", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getSendCountryPartners(country_code) {
      try {
        const responseData = await partnerService.getCountryPartners(
          country_code,
        );
        if (responseData.data.status_code === 200) {
          this.senderPartners = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
        console.log("Partners", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async addPayeeRoute() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        const validate = this.$refs.Addform.validate();
        if (validate) {
          this.loader = true;
          try {
            const response = await setupService.addPayRoutes(this.routeDetails);
            if (response.data.status_code === 200) {
              this.showAlertSuccess(response.data.message);
              this.stoploader();
              this.getAllPayeeRoutes();
              this.showDialog = false;
            } else {
              this.showAlertError(response.data.message);
              this.stoploader();
            }
            console.log("Save data", response);
          } catch (error) {
            this.stoploader();
            console.error(error);
          }
        }
      }
    },
    async getcountryList() {
      this.loader = true;
      try {
        const response = await setupService.getCountrysetupList();
        if (response.data.status_code === 200) {
          this.countryOptions = [
            ...response.data.data.map((i) => {
              return { txt: i.name, val: i.iso_alpha3 };
            }),
          ];
          console.log("countryOptions", this.countryOptions);
          this.stoploader();
        } else {
          this.countryOptions == [];
          this.stoploader();
        }
      } catch (error) {
        this.countryOptions = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getPaymentModes(country_code) {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getpaymentmodeBycntry(country_code);
        if (response.data.status_code === 200) {
          this.method_options = [
            ...response.data.data.map((i) => {
              return {
                txt: i.payment_type.payment_mode,
                val: i.payment_type.payment_mode_code,
              };
            }),
          ];
          console.log("countryOptions", this.method_options);
          this.stoploader();
        } else {
          this.method_options == [];
          this.stoploader();
        }
      } catch (error) {
        this.method_options = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getpartnersByCntry(country_code, payment_mode) {
      this.loaderOverlay = true;
      try {
        const response = await partnerService.getpayoutpartnerBycntry(
          country_code,
          payment_mode,
        );
        if (response.data.status_code === 200) {
          this.partner_list = [
            ...response.data.data.map((i) => {
              return { txt: i.partner_name, val: i.partner_id };
            }),
          ];
          console.log("countryOptions", this.partner_list);
          this.stoploader();
        } else {
          this.partner_list == [];
          this.stoploader();
        }
      } catch (error) {
        this.partner_list = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getBankList(partner_id, payment_mode, active) {
      this.loader = true;
      try {
        const response = await partnerService.getPartnerBankList(
          partner_id,
          payment_mode,
          active,
        );
        if (response.data.status_code === 200) {
          this.bank_list = [
            ...response.data.data.map((i) => {
              return { txt: i.name, val: i.source_id };
            }),
          ];
          this.stoploader();
        } else {
          this.stoploader();
          this.bank_list = [];
        }
        console.log("All Banks", response);
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.bank_list = [];
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.routeSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.routeSummary,
          "routeSummary",
        );
      }
    },

    openDialog() {
      this.showDialog = true;
      this.disableCountry = false;
      this.routeDetails = {};
      this.routeDetails.route_level = "BW";
      this.routeDetails.txn_type = this.filterTxnType;
      this.routeDetails.is_active = true;
      this.routeDetails.bank = "";
    },

    editItem(item) {
      this.showDialog = true;
      this.disableCountry = true;
      this.getById(item.route_id);
    },

    closeDialog() {
      this.showDialog = false;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.width-anchor {
  width: 200px !important;
}

.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.required:after {
  content: " *";
  color: red;
}
</style>
